module.exports = __webpack_public_path__ + "static/media/emissor-r-7.5fe67754.png";